import { Component } from 'react'

import * as h from 'h'

import ProfilePicture from 'components/ProfilePicture'

export default class TopBio extends Component {
  getNameWithWesternOrder (easternName) {
    const name = easternName.split(', ')
    return `${name[1]} ${name[0]}`
  }

  render () {
    const { faculty, theme } = this.props
    const { name, title, department, email } = faculty

    return h.div(h.ca(theme.container),
      h.h(ProfilePicture, {
        faculty,
        theme: { container: theme.profilePicture }
      }),
      h.p(h.ca(theme.name), this.getNameWithWesternOrder(name)),
      h.p(h.ca(theme.title), title),
      h.p(h.ca(theme.department), department),
      h.p(h.ca(theme.email), email)
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/FacultyView/TopBio.js